import { useContext, useEffect } from "react";
import { AppContext } from "../App";
import { useAppStore } from "../useAppStore";

export default function CmsPopups({ mode = "global", shopId = false }) {
  const { settings, popups, getTranslatedString } = useContext(AppContext);
  const {
    filteredPopups,
    setFilteredPopups,
    cartFilteredPopups,
    setCartFilteredPopups,
    cartPopupTrigger,
  } = useAppStore();

  useEffect(() => {
    if (mode == "cart") return;
    setFilteredPopups(
      mode == "shop"
        ? popups.filter((p) => p.type == "popup" && p.shops.find((s) => s.id == shopId))
        : popups.filter((p) => p.type == "popup" && p.shops.length == 0)
    );
  }, [shopId, popups, mode]);

  useEffect(() => {
    if (mode != "cart" || cartPopupTrigger == 0) return;
    setCartFilteredPopups(
      popups.filter(
        (p) => p.type == "popup_cart" && (p.shops.length == 0 || p.shops.find((s) => s.id == shopId))
      )
    );
  }, [cartPopupTrigger]);

  const list = mode == "cart" ? cartFilteredPopups : filteredPopups;
  const setList = mode == "cart" ? setCartFilteredPopups : setFilteredPopups;

  const handleClose = (n) => {
    setList(list.filter((el, i) => i != n));
  };

  if (list.length == 0) return null;

  return (
    <div className="cms-popups">
      {list.map(
        (popup, i) =>
          i == 0 && (
            <div className="cms-popup-content" key={i}>
              {popup.img && (
                <div className="img">
                  <img src={popup.img} alt={popup.title} />
                </div>
              )}
              <div className="cms-popup-text">
                <div className="title">{getTranslatedString(popup, "title")}</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: getTranslatedString(popup, "text"),
                  }}
                />
                <button onClick={() => handleClose(i)} className="button button-primary">
                  {getTranslatedString(popup, "button_label")}
                </button>
              </div>
            </div>
          )
      )}
    </div>
  );
}
